import React, { Fragment, useEffect, useRef } from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

const ActionBar = ({
  actions = [],
  breadcrumbs = [],
  outlined = false,
  onBreadcrumbClick = () => {},
}) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, []);

  return (
    <ActionBarContainer ref={scrollRef}>
      <Breadcrumbs>
        {breadcrumbs.map((breadcrumb, index) => (
          <Fragment key={`breadcrumb-${breadcrumb}-${index}`}>
            <Breadcrumb
              $active={index === breadcrumbs.length - 1}
              onClick={() => onBreadcrumbClick(breadcrumbs[index])}
            >
              {breadcrumb === "Generic Meeting Link" ? (
                <div style={{ fontSize: "16px" }}>{breadcrumb}</div>
              ) : breadcrumb === "Recordings" ? (
                <div style={{ fontSize: "16px" }}>{breadcrumb}</div>
              ) : (
                breadcrumb
              )}
            </Breadcrumb>
            {index < breadcrumbs.length - 1 && <Separator>{">"}</Separator>}
          </Fragment>
        ))}
      </Breadcrumbs>
      {actions.length > 0 && (
        <ActionButtonContainer>
          {actions.map((action, index) => (
            <ActionButton
              type="button"
              $outlined={outlined}
              hidden={action.hidden}
              key={`action-${action.text}-${index}`}
              {...action.props}
            >
              {action.text}
            </ActionButton>
          ))}
        </ActionButtonContainer>
      )}
    </ActionBarContainer>
  );
};

export default ActionBar;

const ActionBarContainer = styled.div`
  border-bottom: 1px solid ${COLORS.BORDER_GREY};
  padding: 10px 53px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px 24px;
  min-height: 55px;
  box-sizing: border-box;
  @media (max-width: 640px) {
    padding: 10px 15px;
  }
`;

const ActionButton = styled.button`
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  background-color: ${({ $outlined }) =>
    $outlined ? COLORS.PRIMARY_WHITE : COLORS.BTN_GREEN};
  color: ${({ $outlined }) =>
    $outlined ? COLORS.BTN_GREEN : COLORS.PRIMARY_WHITE};
  border: 1px solid ${COLORS.BTN_GREEN};
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 0.85;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ActionButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const Breadcrumbs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

const Breadcrumb = styled.div`
  font-size: 14px;
  font-family: ${({ $active }) =>
    $active ? theme.fonts.primaryFontBold : theme.fonts.primaryFontSemiBold};
  cursor: pointer;
  color: ${COLORS.COLOR_DARK};
  user-select: none;
  &:hover {
    text-decoration: ${({ $active }) => ($active ? "none" : "underline")};
  }
`;

const Separator = styled.span`
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
  user-select: none;
`;
